module.exports = __webpack_public_path__ + "img/claimed-in.a6a57ad0.png";